import { useRef, useState, useEffect } from 'react'
import { useApp } from '../app-context'
import { createPortal } from 'react-dom'
interface TimelineProps {
  timelineInterval?: number
}

export const Timeline = ({ timelineInterval = 30 }: TimelineProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [timelineOffset, setTimelineOffset] = useState<number>(0)
  const [isAboveTimeline, setIsAboveTimeline] = useState<boolean>(false)

  const { days, offsetX } = useApp()
  const daysInterval = days.length > 0 ? days.length : 0

  useEffect(() => {
    const updateTimelineOffset = () => {
      setTimeout(() => {
        if (containerRef.current) {
          const rect = containerRef.current.getBoundingClientRect()
          const offset = rect.top + window.scrollY
          setTimelineOffset(offset)
        }
      }, 6000)
    }

    const handleScroll = () => {
      const currentScrollY = window.scrollY
      setIsAboveTimeline(currentScrollY >= timelineOffset)
    }

    // Initial calculation
    updateTimelineOffset()

    // Set up event listeners
    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', updateTimelineOffset)

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', updateTimelineOffset)
    }
  }, [timelineOffset])

  const formatTime = (totalMinutes: number): string => {
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}`
  }

  // how many slots we'll render
  const slotsPerDay = Math.floor((24 * 60) / timelineInterval)
  const totalSlots = (daysInterval * 2 + 1) * slotsPerDay
  const mainElement =
    typeof window !== 'undefined' ? document.querySelector('main') : null
  const portalContainer = mainElement || document.body

  const handleBackToTop = (e: React.MouseEvent<HTMLButtonElement>) => {
    //find element with id id="tv-guide-placeholder"
    const placeholder = document.getElementById('tv-guide-placeholder')

    e.preventDefault()
    if (placeholder) {
      //get placeholder position and scroll to it more 400px
      const { top } = placeholder.getBoundingClientRect()
      window.scrollTo({ top: top + window.scrollY - 200, behavior: 'smooth' })
    }
  }

  return (
    <>
      <div className="screen-readers-only" ref={containerRef}>
        Reference point
      </div>
      {isAboveTimeline &&
        createPortal(
          <div className="timeline fixed-timeline">
            <ul
              className="timeline-list"
              style={{
                transform: `translateX(-${offsetX}px)`,
                // transition: 'transform 0.3s',
              }}
            >
              {Array.from({ length: totalSlots }).map((_, idx) => {
                const slotInDay = idx % slotsPerDay
                const minutes = slotInDay * timelineInterval
                const timeLabel = formatTime(minutes)
                return (
                  <li
                    key={idx}
                    data-time={timeLabel}
                    data-day={days[Math.floor(idx / slotsPerDay)]}
                  >
                    <span>{timeLabel}</span>
                    <span className="middle-divider" />
                  </li>
                )
              })}
            </ul>
          </div>,
          portalContainer
        )}
      {isAboveTimeline &&
        createPortal(
          <button
            type="button"
            className="btn-primary back-to-top icon-seta-fast-up"
            onClick={handleBackToTop}
          >
            <div className="back-to-top-text">Voltar ao topo</div>
          </button>,
          portalContainer
        )}
      {!isAboveTimeline && (
        <div className={`timeline`}>
          <ul className="timeline-list">
            {Array.from({ length: totalSlots }).map((_, idx) => {
              const slotInDay = idx % slotsPerDay
              const minutes = slotInDay * timelineInterval
              const timeLabel = formatTime(minutes)
              return (
                <li
                  key={idx}
                  data-time={timeLabel}
                  data-day={days[Math.floor(idx / slotsPerDay)]}
                >
                  <span>{timeLabel}</span>
                  <span className="middle-divider" />
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </>
  )
}
